export enum DashboardChartType {
  Kpi = 'KPI',
  Pie = 'PIE',
  Bar = 'BAR',
  Line = 'LINE',
}
